import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds === 0) {
          if (prev.minutes === 0) return prev;
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return {
          ...prev,
          seconds: prev.seconds - 1
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="sticky top-0 z-50 bg-[#2D5A27] text-white py-2 px-4 text-center shadow-md border-b border-[#2D5A27]/20" data-id="element-30">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-center items-center gap-2 text-sm sm:text-base font-medium font-['Inter']" data-id="element-31">
        <span className="flex items-center gap-2" data-id="element-32">
          <Clock className="w-4 h-4" data-id="element-33" />
          ¡Oferta por tiempo limitado!
        </span>
        <span className="hidden sm:inline opacity-50" data-id="element-34">|</span>
        <span data-id="element-35">
          Solo quedan{' '}
          <span className="font-bold text-[#FF6B35] underline decoration-[#FF6B35]/50" data-id="element-36">
            7 copias
          </span>{' '}
          a precio promocional
        </span>
        <span className="bg-[#FF6B35] text-white px-2 py-0.5 rounded text-xs font-bold border border-[#cc5529]" data-id="element-37">
          {String(timeLeft.minutes).padStart(2, '0')}:
          {String(timeLeft.seconds).padStart(2, '0')}
        </span>
      </div>
    </div>;
}